import React, { ChangeEvent, useEffect, useRef, useState } from 'react'
import { ApplicationsListInterface } from '../../../modules/accounts/components/settings/SettingsModel';
import { useLocation, useNavigate } from 'react-router-dom';
import { useMutation, useQuery } from 'react-query';
import { toast } from 'react-toastify';
import { update_application } from '../api/applicationsApi';
import { Form } from 'react-bootstrap';
import "../../../../_metronic/assets/keenicons/duotone/style.css";
import { validateImage } from '../../../helper-functions/ImageValidation';
function EditApplication() {
    const [selectedApplication, setSelectedApplication] = useState<ApplicationsListInterface | null>();
    const [logo, setLogo] = useState<File | null>(null);
    const [colorLogo, setColorLogo] = useState<File | null>(null);
    const [favIcon, setFavIcon] =  useState<File | null>(null);
    const [nameError, setNameError] = useState('');
    const [frontEndPrefixError, setFrontEndPrefixError] = useState('');
    const [apiPrefixError, setApiPrefixError] = useState('');
    const [serverUrlError, setServerUrlError] = useState('');
    const [websiteURLError, setWebsiteURLError] = useState('');
    const [apiURLError, setApiURLError] = useState('');
    const [loading, setLoading] = useState(false);
    const location = useLocation();
    const ref = useRef<HTMLInputElement>(null);
    const navigate = useNavigate();
    const application = (location.state as { application: ApplicationsListInterface }).application;
    useEffect(() => {
        setSelectedApplication(application);
    }, [application]);
    const handleNameChange = (e: ChangeEvent<HTMLInputElement>) => {
        if (selectedApplication) {
            const newName = e.target.value;
            if (!newName) {
                setNameError('Application Name is required.');
            } else {
                setNameError('');
            };
            setSelectedApplication({
                ...selectedApplication,
                name: newName,
            });
        };
    };
    const handleServerUrlChange = (e: ChangeEvent<HTMLInputElement>) => {
        if (selectedApplication) {
            const serverUrl = e.target.value;
            if (!serverUrl) {
                setServerUrlError('Server Url is required.');
            } else {
                setServerUrlError('');
            };
            setSelectedApplication({
                ...selectedApplication,
                server_url: serverUrl,
            });
        };
    };
    const handleFrontEndPrefixChange = (e: ChangeEvent<HTMLInputElement>) => {
        if (selectedApplication) {
            const FrontEndPrefix = e.target.value;
            if (!FrontEndPrefix) {
                setFrontEndPrefixError('Frontend Domain Prefix is required.');
            } else {
                setFrontEndPrefixError('');
            };
            setSelectedApplication({
                ...selectedApplication,
                frontend_domain_prefix : FrontEndPrefix,
            });
        };
    };
    const handleApiPrefixChange = (e: ChangeEvent<HTMLInputElement>) => {
        if (selectedApplication) {
            const apiPrefix = e.target.value;
            if (!apiPrefix) {
                setApiPrefixError('API Domain Prefix is required.');
            } else {
                setApiPrefixError('');
            };
            setSelectedApplication({
                ...selectedApplication,
                api_domain_prefix : apiPrefix,
            });
        };
    };
    const handleWebsiteURLChange = (e: ChangeEvent<HTMLInputElement>) => {
        if (selectedApplication) {
            const newWebURL = e.target.value;
            if (!newWebURL) {
                setWebsiteURLError('Website URL is required.');
            } else {
                setWebsiteURLError('');
            };
            setSelectedApplication({
                ...selectedApplication,
                website_url: newWebURL,
            });
        };
    };
        // Function to handle organisation icon change
        const handleIconChange = (e: ChangeEvent<HTMLInputElement>) => {
            if (selectedApplication) {
                const newIcon = e.target.files?.[0] || null;
                setSelectedApplication({
                    ...selectedApplication,
                    favicon: newIcon ? URL.createObjectURL(newIcon) : undefined,
                });
                setFavIcon(newIcon); // Save file for upload
            }
        };
        const handleColorLogoChange = (e: ChangeEvent<HTMLInputElement>) => {
            if (selectedApplication) {
                const newColorLogo = e.target.files?.[0] || null;
                setSelectedApplication({
                    ...selectedApplication,
                    colored_logo: newColorLogo ? URL.createObjectURL(newColorLogo) : selectedApplication.colored_logo,
                });
                setColorLogo(newColorLogo); // Save file for upload
            }
        };
    const handleApiURLChange = (e: ChangeEvent<HTMLInputElement>) => {
        if (selectedApplication) {
            const newApiURL = e.target.value;
            if (!newApiURL) {
                setApiURLError('API URL is required.');
            } else {
                setApiURLError('');
            };
            setSelectedApplication({
                ...selectedApplication,
                api_url: newApiURL,
            });
        };
    };
    const handleDescChange = (e: ChangeEvent<HTMLInputElement>) => {
        if (selectedApplication) {
            const newDescription = e.target.value;
            setSelectedApplication({
                ...selectedApplication,
                description: newDescription,
            });
        };
    };
        const handleImageChange = (
            e: React.ChangeEvent<HTMLInputElement>,
            logoType:string,
            MAX_FILE_SIZE: number,
            ALLOWED_TYPES: string[],
            MAX_DIMENSIONS: { [key: string]: { width: number; height: number } }
          ) => {
            const newFile = e.target.files?.[0];
            if (newFile) {
              // Call the validation function
              validateImage(
                newFile,
                logoType,
                (validFileUrl) => {
                  // If valid, update the state with the image URL
                  if (logoType === 'color_logo') {
                    setColorLogo(newFile);
                  } else if (logoType === 'white_logo') {
                    setLogo(newFile);
                  } else if (logoType === 'favicon') {
                    setFavIcon(newFile);
                  }
                },
                MAX_FILE_SIZE, // File size limit in MB
                ALLOWED_TYPES, // Allowed file types
                MAX_DIMENSIONS // Maximum dimensions per logo type
              );
            }
          };
    const handleStatusChange = (e: any) => {
        if (selectedApplication) {
            const newStatus = e.target.value;
            setSelectedApplication({
                ...selectedApplication,
                status: newStatus,
            });
        }
    };
    const handleUpdateApplication = () => {
        try {
            setLoading(true);
            if (!selectedApplication) {
                throw new Error('No Application Selected for Update');
            }

            const {
                id,
                name,
                website_url,
                api_url,
                description,
                status,
                api_domain_prefix,
                frontend_domain_prefix,
                server_url
            } = selectedApplication;

            const formData = new FormData();
            formData.append('name', name || '');
            formData.append('website_url', website_url || '');
            formData.append('frontend_domain_prefix', frontend_domain_prefix || '');
            formData.append('api_domain_prefix', api_domain_prefix || '');
            formData.append('api_url', api_url || '');
            formData.append('description', description || '');
            formData.append('server_url', server_url || '');
            formData.append('status', status.toString());

            // Append files if they exist
            if (logo) {
                formData.append('white_logo', logo, logo.name);
            }
            if (colorLogo) {
                formData.append('colored_logo', colorLogo, colorLogo.name);
            }
            if (favIcon) {
                formData.append('favicon', favIcon, favIcon.name);
            }
            updateApplicationMutation.mutate({
                id,
                formData,
            });
            // navigate('/applications/applications-list');
        } catch (error: any) {
            toast.error(error.message || 'An error occurred.', {
                position: 'top-right',
                autoClose: 3000,
            });
            setLoading(false);
        }
    };


    const updateApplicationMutation = useMutation((Data: any) => update_application(Data.id, Data.formData), {
        onSuccess: (response) => {
            //   refetch();
            setLoading(false);
            navigate('/applications/applications-list');
            toast.success(response.message, {
                position: 'top-right',
                autoClose: 3000,
            });
            ref.current && (ref.current.value = '')
        },
        onError: (error: any) => {
            if (error.response) {
                toast.error(error.response.data.message, {
                    position: "top-right",
                    autoClose: 3000,
                });
                setLoading(false);
            } else if (error.request) {
                // The request was made but no response was received
                toast.error('No response received from the server.', {
                    position: "top-right",
                    autoClose: 3000,
                });
                setLoading(false);
            } else {
                toast.error('An unexpected error occurred.', {
                    position: "top-right",
                    autoClose: 3000,
                });
            }
            setLoading(false);
        },
    });
    return (
        <div className='card mb-5 mb-xl-10'>
            <div
                className='card-header border-0'
            >
                <h3 className='card-title align-items-start flex-column'>
                    <span className='card-label fw-bolder fs-3 mb-1'>Edit Application</span>
                </h3>
                <div
                    className='card-toolbar'
                    data-bs-toggle='tooltip'
                    data-bs-placement='top'
                    data-bs-trigger='hover'
                >
                    <button
                        data-toggle="tooltip" data-placement="bottom" title="Navigate to List of Applications"
                        className='btn btn-sm btn-light-dark fs-5'
                        onClick={() => navigate('/applications/applications-list')}
                    >
                        List of Applications
                    </button>
                </div>
            </div>
            <div id='kt_account_profile_details' className='collapse show'>
                <div className='card-body border-top p-9'>
                    {selectedApplication ? (
                        <>
                            <div className='row mb-6'>
                                <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                                    <span>Application Name</span>
                                </label>
                                <div className='col-lg-8 fv-row'>
                                    <input
                                        type='text'
                                        className='form-control form-control-lg form-control-solid'
                                        placeholder='Application Name'
                                        value={selectedApplication ? selectedApplication.name : ''}
                                        onChange={(e) => handleNameChange(e)}
                                    />
                                    {nameError && (
                                        <div className='text-danger'>{nameError}</div>
                                    )}
                                </div>
                            </div>
                            <div className='row mb-6'>
                            <label className='col-lg-4 col-form-label required fw-bold fs-6'>Frontend Domain Prefix</label>
                            <div className='col-lg-8 fv-row'>
                            <input
                                        type='text'
                                        className='form-control form-control-lg form-control-solid'
                                        placeholder='Frontend Domain Prefix'
                                        value={selectedApplication ? selectedApplication.frontend_domain_prefix : ''}
                                        onChange={(e) => handleFrontEndPrefixChange(e)}
                                    />
                                    {frontEndPrefixError && (
                                        <div className='text-danger'>{frontEndPrefixError}</div>
                                    )}
                            </div>
                        </div>
                        <div className='row mb-6'>
                            <label className='col-lg-4 col-form-label required fw-bold fs-6'>API Domain Prefix</label>
                            <div className='col-lg-8 fv-row'>
                            <input
                                        type='text'
                                        className='form-control form-control-lg form-control-solid'
                                        placeholder='API Domain Prefix'
                                        value={selectedApplication ? selectedApplication.api_domain_prefix : ''}
                                        onChange={(e) => handleApiPrefixChange(e)}
                                    />
                                    {apiPrefixError && (
                                        <div className='text-danger'>{apiPrefixError}</div>
                                    )}
                            </div>
                        </div>
                            <div className='row mb-6'>
                                <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                                    <span>Website URL</span>
                                </label>
                                <div className='col-lg-8 fv-row'>
                                    <input
                                        type='text'
                                        className='form-control form-control-lg form-control-solid'
                                        placeholder='Website URL'
                                        value={selectedApplication ? selectedApplication.website_url : ''}
                                        onChange={(e) => handleWebsiteURLChange(e)}
                                    />
                                    {websiteURLError && (
                                        <div className='text-danger'>{websiteURLError}</div>
                                    )}
                                </div>
                            </div>
                            <div className='row mb-6'>
                                <label className='col-lg-4 col-form-label required fw-bold fs-6'>API URL</label>
                                <div className='col-lg-8 fv-row'>
                                    <input
                                        type='text'
                                        className='form-control form-control-lg form-control-solid'
                                        placeholder='API URL'
                                        value={selectedApplication ? selectedApplication.api_url : ''}
                                        onChange={(e) => handleApiURLChange(e)}
                                    />
                                {apiURLError && (
                                    <div className='text-danger'>{apiURLError}</div>
                                )}
                                </div>
                            </div>
                            <div className='row mb-6'>
                                <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                                    <span>Server Url</span>
                                </label>
                                <div className='col-lg-8 fv-row'>
                                    <input
                                        type='text'
                                        className='form-control form-control-lg form-control-solid'
                                        placeholder='Server Url'
                                        value={selectedApplication ? selectedApplication.server_url : ''}
                                        onChange={(e) => handleServerUrlChange(e)}
                                    />
                                    {serverUrlError && (
                                        <div className='text-danger'>{serverUrlError}</div>
                                    )}
                                </div>
                            </div>
                            <div className='row mb-6'>
                                <label className='col-lg-4 col-form-label fw-bold fs-6 '>Description</label>
                                <div className='col-lg-8 fv-row'>
                                    <input
                                        type='tel'
                                        className='form-control form-control-lg form-control-solid'
                                        placeholder='Description'
                                        value={selectedApplication ? selectedApplication.description : ''}
                                        onChange={(e) => handleDescChange(e)}
                                    />
                                </div>
                            </div>
                            <div className='row mb-6'>
                                <label className='col-lg-4 col-form-label fw-bold fs-6'>Favicon</label>
                                <div className='col-lg-8 fv-row'>
                                    <input
                                        type='file'
                                        className='form-control form-control-lg form-control-solid'
                                        onChange={(e) => handleImageChange(
                                            e,
                                            'favicon',
                                            2, // Max file size (2MB)
                                            ['image/jpeg', 'image/jpg', 'image/png'], // Allowed types
                                            {
                                              favicon: { width: 100, height: 100 }
                                            } // Max dimensions
                                          )}
                                          accept="image/jpeg, image/jpg, image/png"
                                          name='Favicon'
                                    />
                                    <div className='text-danger mt-2'>
                Recommended size: 100 x 100 px, max file size: 2MB, and accepted file types: jpg, jpeg, or png only.
              </div>
                                    {selectedApplication.favicon && (
                                        <>
                                        <label className='col-lg-4 col-form-label fw-bold fs-6'>Existing Logo:</label>
                                        <div className="mt-2" >
                                                <img
                                                    src={selectedApplication.favicon}
                                                    alt="Color Logo"
                                                    className="img-fluid logo-application-img-icon bg-dark rounded"
                                                />
                                            </div>
                                        </>
                                    )}
                                </div>
                            </div>
                            <div className='row mb-6'>
                                <label className='col-lg-4 col-form-label fw-bold fs-6'>White Logo</label>
                                <div className='col-lg-8 fv-row'>
                                    <input
                                        type='file'
                                        className='form-control form-control-lg form-control-solid'
                                        onChange={(e) => handleImageChange(
                                            e,
                                            'white_logo',
                                            2, // Max file size (2MB)
                                            ['image/jpeg', 'image/jpg', 'image/png'], // Allowed types
                                            {
                                                white_logo: { width: 400, height: 400 }
                                            } // Max dimensions
                                          )}
                                          accept="image/jpeg, image/jpg, image/png"
                                    />
                <div className='text-danger mt-2'>
                Recommended size: 400 x 400 px, max file size: 2MB, and accepted file types: jpg, jpeg, or png only.
              </div>
                                    {selectedApplication.white_logo && (
                                        <>
                                        <label className='col-lg-4 col-form-label fw-bold fs-6'>Existing Logo:</label>
                                        <div className="mt-2" >
                                                <img
                                                    src={selectedApplication.white_logo}
                                                    alt="Color Logo"
                                                    className="img-fluid logo-application-img bg-dark rounded"
                                                />
                                            </div>
                                        </>
                                    )}
                                </div>
                            </div>
                            <div className='row mb-6'>
                                <label className='col-lg-4 col-form-label fw-bold fs-6'>Coloured Logo</label>
                                <div className='col-lg-8 fv-row'>
                                    <input
                                        type='file'
                                        className='form-control form-control-lg form-control-solid'
                                        onChange={(e) => handleImageChange(
                                            e,
                                            'color_logo',
                                            2, // Max file size (2MB)
                                            ['image/jpeg', 'image/jpg', 'image/png'], // Allowed types
                                            {
                                                color_logo: { width: 400, height: 400 }
                                            } // Max dimensions
                                          )}
                                          accept="image/jpeg, image/jpg, image/png"
                                          name='Coloured Logo'
                                    />
                                                    <div className='text-danger mt-2'>
                Recommended size: 400 x 400 px, max file size: 2MB, and accepted file types: jpg, jpeg, or png only.
              </div>
                                    {selectedApplication.colored_logo && (
                                        <>
                                        <label className='col-lg-4 col-form-label fw-bold fs-6'>Existing Logo:</label>
                                        <div className="mt-2" >
                                                <img
                                                    src={selectedApplication.colored_logo}
                                                    alt="Color Logo"
                                                    className="img-fluid logo-application-img bg-dark rounded"
                                                />
                                            </div>
                                        </>
                                    )}
                                </div>
                            </div>
                            <div className='row mb-6'>
                                <label className='col-lg-4 col-form-label fw-bold fs-6'>
                                    <span>Status</span>
                                </label>
                                <div className='col-lg-8 fv-row'>
                                    <Form.Select
                                        className='form-select form-select-solid form-select-lg fw-bold'
                                        value={selectedApplication ? selectedApplication.status : ''}
                                        onChange={(e) => handleStatusChange(e)}
                                    >
                                        <option value={1}>Active</option>
                                        <option value={0}>Inactive</option>
                                    </Form.Select>
                                </div>
                            </div>
                        </>
                    ) : null}
                </div>
                <div className='card-footer d-flex justify-content-end py-6 px-9'>
                    {nameError || websiteURLError || apiURLError || frontEndPrefixError || apiPrefixError || serverUrlError? (
                        <button type='button' data-toggle="tooltip" data-placement="bottom" title="Update Application" className='btn btn-primary disabled'>
                            Update Application
                        </button>
                    ) : (
                        <button
                            data-toggle="tooltip" data-placement="bottom" title="Update Application"
                            type='button'
                            className='btn btn-primary'
                            onClick={handleUpdateApplication}
                            disabled={loading}
                        >
                            {!loading && 'Update Application'}
                            {loading && (
                                <span className='indicator-progress' style={{ display: 'block' }}>
                                    Please wait...{' '}
                                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                </span>
                            )}
                        </button>
                    )}
                </div>
            </div>
        </div>
    )
}


export default EditApplication